/* eslint-env jquery */

export default class AccountReactivator {
  constructor(planId, billingPeriod, discountCode,
    paymentNonce, postalCode, paymentOnFile, controller, gateway, stripePaymentMethodId = null, stripePaymentMethodType = null) {
    const humbleBundle = controller.data.get("humbleBundle");
    
    // For Humble Bundle, only send minimal required params
    if (humbleBundle) {
      this.body = {
        plan_id: planId,
        humble_bundle: humbleBundle
      };
    } else {
      this.body = {
        plan_id: planId,
        billing_period: billingPeriod,
        discount_code: discountCode,
        nonce: paymentNonce,
        postal_code: postalCode,
        payment_on_file: paymentOnFile,
        gateway,
        stripe_payment_method_id: stripePaymentMethodId,
        stripe_payment_method_type: stripePaymentMethodType
      };
    }
    this.controller = controller;
  }

  setPlanType = (type) => {
    this.planType = type;
    this.body.plan_type = type;
  }

  showReactivationError = (message) => {
    $("#error-modal-content").html(message);
    $("#errorModal").css("display", "block");
    $(".modal-overlay").css("display", "block");
    $("#errorModal a.modal-close-extra").click(() => {
      $(".modal-overlay").css("display", "none");
    });
  }

  reactivate = () => {
    const postUrl = this.controller.data.get("postUrl");
    const self = this;
    $.post(postUrl, { account_reactivation: this.body }, (response) => {
      if (response.response.reactivated) {
        window.location.href = this.controller.data.get("redirectUrl");
      } else if (response.status === 406) {
        self.showReactivationError(response.message);
        this.controller.enableSubmitBtn();
      } else if (response.status === 402) {
        self.showReactivationError(response.message);
        this.controller.enableSubmitBtn();
      }
    }).fail((xhr) => {
      // Handle error responses (non-2xx status codes)
      const response = xhr.responseJSON;
      if (response && (response.status === 406 || response.status === 402)) {
        self.showReactivationError(response.message);
      } else {
        self.showReactivationError("An error occurred while processing your request. Please try again.");
      }
      self.controller.enableSubmitBtn();
    });
  }
}
